import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { openBookConsultation } from "../../lib/bookConsultation";

export default function ClosingCTA() {
  return (
    <section
      data-testid="closing-cta"
      className="section-dark py-28 md:py-40 relative overflow-hidden"
    >
      <div className="absolute inset-0">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[120vw] h-[120vw] max-w-[1400px] max-h-[1400px] rounded-full bg-[radial-gradient(circle,rgba(255,176,0,0.18),transparent_55%)] blur-3xl" />
      </div>
      <div className="grain-overlay" />
      <div className="container-xl relative text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="text-[11px] uppercase tracking-[0.22em] text-white/50 mb-8">
            Let&apos;s build something
          </div>
          <h2
            className="font-display text-white font-semibold tracking-tighter leading-[0.95]"
            style={{ fontSize: "clamp(48px, 9vw, 180px)", letterSpacing: "-0.05em" }}
          >
            Let&apos;s build <br />
            your <span className="font-serif italic font-light text-[#FFB000]">pipeline.</span>
          </h2>

          <p className="mt-10 text-white/70 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            Tell us where you stand. We&apos;ll tell you what&apos;s working,
            what&apos;s broken, and how to grow — backed by data and AI.
          </p>

          <div className="mt-14 flex flex-wrap items-center justify-center gap-3">
            <button
              type="button"
              onClick={() => openBookConsultation("home_closing_cta")}
              data-testid="closing-cta-primary"
              className="btn-pill btn-primary-amber text-[15px] px-7 py-4"
            >
              Book a consultation
              <ArrowUpRight size={16} strokeWidth={2.2} />
            </button>
            <a
              href="/work"
              data-testid="closing-cta-secondary"
              className="btn-pill btn-ghost-dark text-[15px] px-7 py-4"
            >
              See our work
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
